var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191A1A",
    d: "M8.468 1.167c.263 0 .516.105.702.291l2.79 2.797c.185.187.29.44.29.704v6.31c0 .864-.699 1.564-1.56 1.564H3.31c-.861 0-1.56-.7-1.56-1.565V2.732c0-.865.699-1.565 1.56-1.565h5.158Zm-.617.853h-4.54a.71.71 0 0 0-.71.712v8.536a.71.71 0 0 0 .71.712h7.378a.71.71 0 0 0 .71-.712V5.435H8.56a.71.71 0 0 1-.706-.639l-.004-.072V2.02Zm3.23 2.561L8.702 2.197v2.384h2.377Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#191A1A",
    d: "M3.453 6.289V9.14h.596v-.797h.433c.631 0 1.057-.398 1.057-1.028 0-.629-.422-1.027-1.053-1.027H3.453Zm.596 1.482v-.909h.389c.306 0 .493.156.493.454 0 .291-.187.455-.497.455h-.385ZM5.878 6.289V9.14h.985c.874 0 1.434-.522 1.434-1.422 0-.893-.556-1.43-1.43-1.43h-.99Zm.596 2.278V6.862h.353c.509 0 .858.275.858.857 0 .593-.353.848-.862.848h-.35ZM10.428 6.289H8.644V9.14h.596V8.049h.973v-.573H9.24v-.614h1.188V6.29Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.af28e1e36e65f2ce78277895ee6cc492.svg";
export { ForwardRef as ReactComponent };